import { render, staticRenderFns } from "./order1.vue?vue&type=template&id=6828786d&scoped=true"
import script from "./order1.vue?vue&type=script&lang=js"
export * from "./order1.vue?vue&type=script&lang=js"
import style0 from "./order1.vue?vue&type=style&index=0&id=6828786d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6828786d",
  null
  
)

export default component.exports